<template>
  <div v-if="cert_data != null">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <center>
      <v-btn class="button no-display" @click="print"> Print </v-btn>
      <v-btn class="button no-display" rounded @click="close()"> Close </v-btn>
    </center>
    <!-- code for SAK, SAV, SIS -->
    <template>
      <div v-if="show == true" id="document1">
        <!-- SAK Bonafide -->
        <div class="printdiv" v-if="org_id == '1'">
          <v-row justify="center">
            <v-col cols="2" sm="2" md="2" align="center">
              <span style="font-weight: bolder"
                >CBSE Affiliation <br />No: {{ org_basic_data.cbsc_no }}</span
              >
              <img
                v-if="org_basic_data.school_logo"
                class="sak-logo"
                :src="org_basic_data.school_logo"
                width="135px"
                height="90px"
                style="margin-left: -10px; margin-bottom: -10px"
                alt="logo"
              />
              <span class="sak" style="">Sanjivani Academy</span>
            </v-col>
            <v-col cols="12" sm="10" md="10">
              <strong
                ><span
                  style="padding-left: 26%"
                  v-if="org_basic_data.trust_name"
                  >{{ org_basic_data.trust_name }}</span
                ></strong
              >
              <strong
                ><span class="udise"
                  >Udise No : {{ cert_data.udise_no }}</span
                ></strong
              >
              <strong
                ><h1
                  v-if="org_id == '1'"
                  style="padding-left: 25%"
                  class="header-style"
                >
                  Sanjivani <span class="span-first-letter">A</span>cademy
                </h1>
                <h1 v-else style="text-align: center">
                  {{ org_basic_data.school_name }}
                </h1></strong
              >
              <strong
                ><span class="header" v-if="org_basic_data.address"
                  >{{ org_basic_data.address }} - {{ org_basic_data.pin }}</span
                ></strong
              >

              <v-row dense class="header">
                <v-col cols="5">
                  <span class="text-css" v-if="org_basic_data.phone"
                    >Phone : {{ org_basic_data.phone }}</span
                  >
                </v-col>
                <v-col cols="6">
                  <span class="text-css pl-3" v-if="org_basic_data.address"
                    >Fax : (02423) 222682
                  </span>
                </v-col>
              </v-row>
              <v-row dense style="margin-top: -4px" class="header">
                <v-col cols="5">
                  <span class="text-css" v-if="org_basic_data.email"
                    >e-mail : {{ org_basic_data.email }}</span
                  >
                </v-col>
                <v-col cols="7">
                  <span class="text-css pl-3" v-if="org_basic_data.website"
                    >website : {{ org_basic_data.website }}</span
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <hr style="border: solid 1px" />
          <v-row justify="center" class="ml-2">
            <v-col cols="12" sm="4" md="4">
              <strong>SRES/SA/{{ cert_data.ay }}/{{ cert_data.cert_no }}</strong
              ><br />
            </v-col>
            <v-col cols="12" sm="5" md="5"></v-col>
            <v-col align="right" cols="12" sm="3" md="3">
              <strong>
                <span style="margin-right: 15%"
                  >Date : {{ cert_data.cert_date }}
                </span>
              </strong>
            </v-col>
          </v-row>
          <center>
            <strong>
              <span class="certificate-text">Bonafide Certificate</span>
            </strong>
          </center>
          <br />
          <v-row class="main-row">
            <v-col cols="12" sm="12" md="12" style="font-size: 1.3em">
              <span style="padding-left: 110px"
                >This is to verify that Mast/Miss
              </span>
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    text-align: center;
                    width: 45%;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.stud_name }}</span
                ></strong
              >
              is a
              <br />
              <br />
              <span
                >student of our school studying in Grade
                <strong
                  ><span
                    style="
                      border-bottom: 2px solid #000;
                      text-align: center;
                      width: 17%;
                      display: inline-block;
                      line-height: 1;
                    "
                    >{{ cert_data.std }}</span
                  ></strong
                >
              </span>
              Div
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 6%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.div }}</span
                ></strong
              >
              in the academic<br><br>year 
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    text-align: center;
                    width: 12%;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.ay }}</span
                >.</strong
              >
              
              His / Her date of birth according to our record is
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 20%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.dob }}</span
                >.</strong
              >
              <br />
              <br />
              (In words
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 86%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.dob_words }}</span
                >)</strong
              >
              <br />
              <br />
              Place of Birth
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 22%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.place_of_birth }}</span
                ></strong
              >
              Caste
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 32%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.religion }} - {{ cert_data.caste }}</span
                ></strong
              >
              .To the best of
              <br />
              <br />
              my knowledge, he/she bears a good moral character.
            </v-col>
          </v-row>
          <br />

          <v-row
            dense
            style="font-size: 1.3em; margin-left: 8px; padding-left: 4px"
          >
            <b
              ><span>G.R.No. : {{ cert_data.gr_no }} </span></b
            >
          </v-row>
          <br /><br />
          <v-row
            dense
            style="font-size: 1.3em; margin-left: 8px; padding-left: 4px"
          >
            <b
              ><span>PRN : {{ prno }} </span></b
            >
          </v-row>
          <br /><br />
          <v-row
            dense
            style="font-size: 1.3em; margin-left: 8px; padding-left: 4px"
          >
            <strong><span>Place : Kopargaon </span></strong>
          </v-row>
          <br />
          <br />
          <div
            style="
              font-size: 1.3em;
              float: left;
              padding-left: 2px;
              margin-left: 8px;
            "
          >
            <strong>Date : {{ cert_data.cert_date }}</strong>
          </div>
          <div
            style="
              font-size: 1.3em;
              float: right;
              padding-right: 2px;
              margin-right: 58px;
            "
          >
            <strong>PRINCIPAL</strong>
          </div>
          <br />
          <br />
        </div>
        <!-- SAV bonafide -->
        <div class="printdiv" v-if="org_id == '3'">
          <v-row justify="center">
            <v-col cols="2" sm="2" md="2" align="center">
              <img
                v-if="org_basic_data.school_logo"
                class="sav-logo"
                src="https://eduplusschool.s3.ap-south-1.amazonaws.com/sanjavani/SGI_LOGO_DARK.png"
                width="145px"
                height="100px"
                style="
                  margin-left: -10px;
                  margin-bottom: -15px;
                  margin-top: 50px;
                "
                alt="logo"
              />
            </v-col>
            <v-col cols="12" sm="10" md="10">
              <strong
                ><span
                  style="padding-left: 26%"
                  v-if="org_basic_data.trust_name"
                  >{{ org_basic_data.trust_name }}</span
                ></strong
              >
              <strong
                ><h1 style="padding-left: 17%">
                  {{ org_basic_data.school_name }}
                </h1></strong
              >
              <strong
                ><span class="header addrs" v-if="org_basic_data.address"
                  >{{ org_basic_data.address }} - {{ org_basic_data.pin }}</span
                ></strong
              >

              <v-row dense class="header">
                <v-col cols="5">
                  <span class="text-css" v-if="org_basic_data.phone"
                    >Phone : {{ org_basic_data.phone }}</span
                  >
                </v-col>
                <v-col cols="6">
                  <span class="text-css pl-3" v-if="org_basic_data.address"
                    >e-mail : {{ org_basic_data.email }}
                  </span>
                </v-col>
              </v-row>
              <v-row dense style="margin-top: -4px" class="header">
                <v-col cols="8" class="text-center">
                  <span class="text-css pl-3" v-if="org_basic_data.website"
                    >website : {{ org_basic_data.website }}</span
                  >
                </v-col>
              </v-row>
              <v-row class="pr-8" dense>
                <v-col cols="12" sm="5" md="5" class="pb-0"
                  ><b
                    >CBSE Affiliation No: {{ org_basic_data.cbsc_no }}</b
                  ></v-col
                >
                <v-col cols="12" sm="7" md="7" class="text-right pb-0"
                  ><b>Udise No : {{ cert_data.udise_no }}</b></v-col
                >
              </v-row>
            </v-col>
          </v-row>
          <hr style="border: solid 1px" />
          <v-row justify="center" class="ml-2">
            <v-col cols="12" sm="4" md="4">
              <strong>SRES/SAV/{{ cert_data.ay }}/</strong
              ><br />
            </v-col>
            <v-col cols="12" sm="5" md="5"></v-col>
            <v-col align="right" cols="12" sm="3" md="3">
              <strong>
                <span style="margin-right: 15%"
                  >Date : {{ cert_data.cert_date }}
                </span>
              </strong>
            </v-col>
          </v-row>
          <center>
            <strong>
              <span class="certificate-text">Bonafide Certificate</span>
            </strong>
          </center>
          <br />
          <v-row class="main-row">
            <v-col cols="12" sm="12" md="12" style="font-size: 1.3em">
              <span style="padding-left: 110px"
                >This is to verify that Mast/Miss
              </span>
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    text-align: center;
                    width: 45%;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.stud_name }}</span
                ></strong
              >
              is a
              <br />
              <br />
              <span
                >bonafide student of our school studying in Grade
                <strong
                  ><span
                    style="
                      border-bottom: 2px solid #000;
                      text-align: center;
                      width: 17%;
                      display: inline-block;
                      line-height: 1;
                    "
                    >{{ cert_data.std }}</span
                  ></strong
                >
              </span>
              Div
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 6%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.div }}</span
                ></strong
              >
              in the <br /><br />
              academic year
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    text-align: center;
                    width: 12%;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.ay }}</span
                >.</strong
              >
              <br />
              <br />
              His / Her Date of birth according to our record is
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 20%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.dob }}</span
                >.</strong
              >
              <br />
              <br />
              (In words
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 86%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.dob_words }}</span
                >)</strong
              >
              <br />
              <br />
              Place of Birth
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 22%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.place_of_birth }}</span
                >.</strong
              >
            </v-col>
          </v-row>
          <br />
          <br />
          <v-row
            dense
            style="font-size: 1.3em; margin-left: 8px; padding-left: 4px"
          >
            <strong><span>Place : Vaijapur </span></strong>
          </v-row>
          <br />
          <br />
          <div
            style="
              font-size: 1.3em;
              float: right;
              padding-right: 2px;
              margin-right: 58px;
            "
          >
            <strong>Principal</strong>
          </div>
          <br />
          <br />
        </div>
        <!-- SIS bonafide -->
        <div class="printdiv" v-if="org_id == '2'">
          <v-row justify="center">
            <v-col cols="2" sm="2" md="2" align="center">
              <img
                v-if="org_basic_data.school_logo"
                class="sis-logo"
                :src="org_basic_data.school_logo"
                width="135px"
                height="90px"
                style="margin-left: -10px; margin-bottom: -10px"
                alt="logo"
              />
            </v-col>
            <v-col cols="12" sm="10" md="10">
              <strong
                ><span
                  style="padding-left: 26%"
                  v-if="org_basic_data.trust_name"
                  >{{ org_basic_data.trust_name }}</span
                ></strong
              >

              <strong
                ><h1 style="padding-left: 16%">
                  {{ org_basic_data.school_name }}
                </h1></strong
              >
              <b style="padding-left: 35%">(Non Grantable)</b><br />
              <strong
                ><span class="header" v-if="org_basic_data.address"
                  >{{ org_basic_data.address }} - {{ org_basic_data.pin }}</span
                ></strong
              >

              <v-row dense style="margin-top: -4px" class="header">
                <v-col cols="5">
                  <span class="text-css" v-if="org_basic_data.email"
                    >e-mail : {{ org_basic_data.email }}</span
                  >
                </v-col>
                <v-col cols="7">
                  <span class="text-css pl-3" v-if="org_basic_data.website"
                    >website : {{ org_basic_data.website }}</span
                  >
                </v-col>
              </v-row>
            </v-col>
            <v-row>
              <v-col
                cols="12"
                sm="4"
                md="4"
                class="pb-0 pt-0"
                style="text-align: left; padding-left: 30px"
                ><b><span>School Code : 31194</span></b></v-col
              >
              <v-col
                cols="12"
                sm="4"
                md="4"
                class="pb-0 pt-0"
                style="text-align: left"
                ><b
                  ><span class="udise"
                    >Udise No : {{ cert_data.udise_no }}</span
                  ></b
                ></v-col
              >
              <v-col
                cols="12"
                sm="4"
                md="4"
                class="pb-0 pt-0"
                style="text-align: right; padding-right: 30px"
                ><span style="font-weight: bolder"
                  >Affiliation No: {{ org_basic_data.cbsc_no }}</span
                ></v-col
              >
            </v-row>
          </v-row>
          <hr style="border: solid 1px" />
          <v-row justify="center" class="ml-2">
            <v-col cols="12" sm="4" md="4">
              <strong>SRES/SIS/{{ cert_data.ay }}</strong
              ><br />
            </v-col>
            <v-col cols="12" sm="5" md="5"></v-col>
            <v-col align="right" cols="12" sm="3" md="3">
              <strong>
                <span style="margin-right: 15%"
                  >Date : {{ cert_data.cert_date }}
                </span>
              </strong>
            </v-col>
          </v-row>
          <center>
            <strong>
              <span class="certificate-text">Bonafide Certificate</span>
            </strong>
          </center>
          <br />
          <v-row class="main-row">
            <v-col cols="12" sm="12" md="12" style="font-size: 1.3em">
              <span style="padding-left: 110px"
                >This is to verify that Mast/Miss
              </span>
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    text-align: center;
                    width: 45%;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.stud_name }}</span
                ></strong
              >
              is a
              <br />
              <br />
              <span
                >student of our school studying in Grade
                <strong
                  ><span
                    style="
                      border-bottom: 2px solid #000;
                      text-align: center;
                      width: 17%;
                      display: inline-block;
                      line-height: 1;
                    "
                    >{{ cert_data.std }}</span
                  ></strong
                >
              </span>
              Div
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 19%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.div }}</span
                ></strong
              >
              <br /><br />
              G.R.No.
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 13%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.gr_no }}</span
                ></strong
              >
               in the academic year
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    text-align: center;
                    width: 12%;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.ay }}</span
                >.</strong
              >
              <br />
              <br />
              His / Her Date of birth according to our record is
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 20%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.dob }}</span
                >.</strong
              >
              <br />
              <br />
              (In words
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 86%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.dob_words }}</span
                >)</strong
              >
              <br />
              <br />
              Place of Birth
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 22%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.place_of_birth }}</span
                ></strong
              >
              Caste
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 32%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.caste }}</span
                ></strong
              >
              .To the best of 
              <br />
              <br />
              my knowledge, he/she bears a good moral character.
            </v-col>
          </v-row>
          <br />
          <br />
          <v-row
            dense
            style="font-size: 1.3em; margin-left: 8px; padding-left: 4px"
          >
            <strong><span>Place : Shirdi </span></strong>
          </v-row>
          <br />
          <br />
          <div
            style="
              font-size: 1.3em;
              float: left;
              padding-left: 2px;
              margin-left: 8px;
            "
          >
            <strong>Date : {{ cert_data.cert_date }}</strong>
          </div>
          <div
            style="
              font-size: 1.3em;
              float: right;
              padding-right: 2px;
              margin-right: 58px;
            "
          >
            <strong>PRINCIPAL</strong>
          </div>
          <br />
          <br />
        </div>
        <!-- STY bonafide -->
        <div class="printdiv" v-if="org_id == '7'">
          <center>{{ org_basic_data.trust_name }}</center>
          <img
                v-if="org_basic_data.school_logo"
                class="sty-logo"
                :src="org_basic_data.school_logo"
                width="935px"
                height="190px"                
                alt="logo"
              />
              <center><h1>Yeola</h1></center>
          <hr style="border: solid 1px" />
          <v-row justify="center" class="ml-2">
            <v-col cols="12" sm="4" md="4">
              <strong>SRES/STY/{{ cert_data.ay }}/{{ cert_data.cert_no }}</strong
              ><br />
            </v-col>
            <v-col cols="12" sm="5" md="5"></v-col>
            <v-col align="right" cols="12" sm="3" md="3">
              <strong>
                <span style="margin-right: 15%"
                  >Date : {{ cert_data.cert_date }}
                </span>
              </strong>
            </v-col>
          </v-row>
          <center>
            <strong>
              <span class="certificate-text">Bonafide Certificate</span>
            </strong>
          </center>
          <br />
          <v-row class="main-row">
            <v-col cols="12" sm="12" md="12" style="font-size: 1.3em">
              <span style="padding-left: 110px"
                >This is to certify that Mast/Miss.
              </span>
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    text-align: center;
                    width: 45%;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.stud_name }}</span
                ></strong
              >
              is a
              <br />
              <br />
              <span
                >student of our school studying in Grade
                <strong
                  ><span
                    style="
                      border-bottom: 2px solid #000;
                      text-align: center;
                      width: 17%;
                      display: inline-block;
                      line-height: 1;
                    "
                    >{{ cert_data.std }}</span
                  ></strong
                >
              </span>
              Div
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 6%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.div }}</span
                ></strong
              >
              in the academic<br><br>year 
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    text-align: center;
                    width: 12%;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.ay }}</span
                >.</strong
              >
              
              His / Her date of birth according to our record is
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 20%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.dob }}</span
                >.</strong
              >
              <br />
              <br />
              (In words
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 86%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.dob_words }}</span
                >)</strong
              >
              <br />
              <br />
              Place of Birth
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 22%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.place_of_birth }}</span
                ></strong
              >
              Caste
              <strong
                ><span
                  style="
                    border-bottom: 2px solid #000;
                    width: 32%;
                    text-align: center;
                    display: inline-block;
                    line-height: 1;
                  "
                  >{{ cert_data.religion }} - {{ cert_data.caste }}</span
                ></strong
              >
              .To the best of
              <br />
              <br />
              my knowledge, he/she bears a good moral character.
            </v-col>
          </v-row>
          <br />
          <br /><br />
          <br /><br />
          <v-row
            dense
            style="font-size: 1.3em; margin-left: 8px; padding-left: 4px"
          >
            <strong><span>Place : Yeola </span></strong>
          </v-row>
          <br />
          <br />
          <div
            style="
              font-size: 1.3em;
              float: left;
              padding-left: 2px;
              margin-left: 8px;
            "
          >
            <strong>Date : {{ cert_data.cert_date }}</strong>
          </div>
          <div
            style="
              font-size: 1.3em;
              float: right;
              padding-right: 2px;
              margin-right: 58px;
            "
          >
            <strong>PRINCIPAL</strong>
          </div>
          <br />
          <br />
        </div>
      </div>
    </template>
  </div>
</template>
  
  <script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      snackbar: false,
      fetch_loader: false,
      gen_cert_loader: false,
      show_cert_loader: false,
      search: "",
      dialog: false,
      awspath: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      data_list: [],
      ay_std_div_list: null,
      sel_ay_data: null,
      cert_data: null,
      std_div_list: null,
      sel_std_data: null,
      div_list: null,
      div: null,
      overlay: false,
      show: true,
      org_id: null,
      org_basic_data: [],
      progress: 0,
      prno: "",
    };
  },
  watch: {
    progress(val) {
      this.$emit("progress", val);
    },
  },
  methods: {
    print() {
            var content = document.getElementById("document1").innerHTML;
            var mywindow = document.body.innerHTML;
            document.body.innerHTML = content;
            window.print();
            document.body.innerHTML = mywindow;
            location.reload();
            return true;
        },
    close() {
      this.$router.push({ name: "certificate-bonafied", target: "blank" });
    },
    onload() {
      this.cert_data = JSON.parse(this.$route.query.cert_data || '{}');
      this.org_basic_data = JSON.parse(this.$route.query.org_basic_data || '{}');
      this.prno = this.$route.query.prno || "";
    },
  },
  mounted() {
    this.awspath = localStorage.getItem("awspath");
    this.org_id = localStorage.getItem("EPS-org-id");
    this.onload();
  },
};
</script>
  <style scoped>
.header-style {
  font-family: serif;
  font-size: 2em;
}
.header-style::first-letter {
  font-family: "GregorianFLF", serif;
}
.header-style .span-first-letter {
  font-family: "GregorianFLF", serif;
}
.certificate-text {
  /* display: inline-block; */
  padding: 5px 50px;
  background-color: black;
  border-radius: 20px;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 1.2em;
}
.text-css {
  font-weight: bolder;
}
.main-row {
  margin-left: 2px;
  margin-right: 2px;
}
.udise {
  padding-left: 13%;
}
.sak {
  text-transform: uppercase;
  font-weight: bolder;
  font-size: 12px;
}
.sav {
  text-transform: uppercase;
  font-weight: bolder;
  margin-top: -20px;
}
.printdiv {
  padding: 10px;
  width: 1000px;
  background-color: white;
  margin: auto;
  /* position: absolute; */
  /* margin-left: 17%; */
}
.addrs {
  font-size: 14px;
}
@media print {
  .printdiv {
    width: 1450px;
    /* height: 1790px; */
    margin-left: -16px !important;
    /* margin-top: -105px !important; */
    margin-right: -50px !important;
    font-size: 1.7em !important;
    padding-left: 100px;
  }
  .sty-logo{
    width: 1235px !important;
    height: 270px !important;
  }
  h1 {
    font-size: 55px !important;
    margin-bottom: 10px;
  }
  .certificate-text {
    font-size: 40px !important;
  }
  .udise {
    padding-left: 5% !important;
  }
  .header {
    line-height: 170% !important;
    font-size: 28px !important;
    margin-top: 10px;
  }
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  .sak-logo {
    width: 250px !important;
    height: 170px !important;
    /* margin-top: 30px !important; */
    margin-left: -20px;
  }
  .sav-logo {
    width: 235px !important;
    height: 180px !important;
    margin-top: -10px !important;
    margin-left: -20px;
  }
  .sis-logo {
    width: 233px !important;
    height: 173px !important;
    /* margin-top: -10px !important; */
    margin-left: -20px;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  .sak {
    font-weight: bolder;
    font-size: 20px;
    margin-left: -12px;
  }
  @page {
    /* size: 25.5in 19in; */
    size: 13.5in 16.5in !important;
  }
  * {
    overflow: hidden !important;
  }
}
</style>
  